module.exports = "sw $t0, 100($zero)\nsh $t0, 104($zero)\nsb $t0, 108($zero)\n\nlw $t1, 100($zero)\nlh $t2, 104($zero)\nlb $t3, 108($zero)\n"